<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <smr-menu-button></smr-menu-button>
    </ion-buttons>
    <ion-title> Products </ion-title>

    <ion-buttons slot="end" *ngIf="!isMobile">
      <ion-button
        fill="outline"
        expand="block"
        color="primary"
        [disabled]="isLoading || errorOccurredWhileLoadingProducts"
        routerLink="/products/0"
      >
        <ion-icon name="add"></ion-icon>New Product
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-toolbar>
    <form [formGroup]="searchForm">
      <ion-searchbar
        class="ion-no-padding"
        type="search"
        animated="true"
        placeholder="Search keywords"
        formControlName="searchField"
      >
      </ion-searchbar>
    </form>
  </ion-toolbar>
</ion-header>



<ion-content class="ion-text-center">
  <!-- (newProduct)="create($event)" -->

  <smr-product-list
    *ngIf="!(isLoading || errorOccurredWhileLoadingProducts)"
    [products]="isSearching ? searchedList : products"
    [isSearching]="products.count() > 0 ? isSearching : false"
    [shouldShowMoreInfo]="true"
    (productSelect)="editProduct($event)"
    (newProduct)="newProduct()"
  >
  </smr-product-list>

  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingProducts"
    (click)="onTapToReload()"
  ></salonmonster-tap-retry>

  <ion-fab
    slot="fixed"
    vertical="bottom"
    horizontal="end"
    *ngIf="isMobile"
    routerLink="/products/0"
  >
    <ion-fab-button>
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
